module.exports = require("core-js/library/fn/object/create");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/object/create.js
 ** module id = 257
 ** module chunks = 0
 **/